import React from "react";
import useWindowDimensions from "../../core/WindowDimensions/useWindowDimensions"
import "./ProgressBarStyles.css";
import "bootstrap/dist/css/bootstrap.css"

function ProgressBar({ percent=6.1, backgroundHeight=32, progressBarHeight=40}) {
  const { width } = useWindowDimensions();
  percent = parseFloat(percent)
  let fontSize = 16
  if (width < 650)
  {
    fontSize = 13
    backgroundHeight = backgroundHeight*0.75
    progressBarHeight = progressBarHeight*0.75
  }

  const marginTop = -(progressBarHeight + backgroundHeight) / 2
  const progressBarStyle = {
    "width": percent < 0.5 ? "0.5%" :String(percent) + "%",
    "marginTop": marginTop,
    "height": progressBarHeight
  }

  const progressBarTextStyle = {
    "fontSize": String(fontSize) + "px",
    "width": percent < 0.5 ? "0.5%" :String(percent) + "%",
    "height": backgroundHeight
  }

  return (
    <div className="progress-bar-wrapper">    
      <div className="progress-bar-background" style={{"height": backgroundHeight}} />
      <div className="progress-bar progress-bar-striped bg-green active" role="progressbar" style={progressBarStyle} />
      <div style={progressBarTextStyle} className="progress-text"><button>{String(percent.toFixed(1)) + "%"}</button></div>
    </div>
  );
}

export default ProgressBar;
